import { __assign, __read } from "tslib";
import React, { useState, useEffect } from 'react';
import './FeetypeRecommend.less';
import { T } from '@ekuaibao/i18n';
import { Tag } from '@hose/eui';
import FeeTypeIcon from './feetype-icon';
import classNames from 'classnames';
import { getSpecificationName } from '../lib/lib-util';
var CLICK_RECOMEND = false;
export default function (props) {
    var _a = props.recommends, recommends = _a === void 0 ? [] : _a, selectedId = props.selectedId, useTreeSelectRC = props.useTreeSelectRC;
    var defaultValue = recommends.length ? recommends[0] : undefined;
    if (selectedId && recommends.length) {
        defaultValue = recommends.find(function (line) { return line.id === selectedId; });
    }
    var _b = __read(useState(defaultValue), 2), value = _b[0], setSelectValue = _b[1];
    useEffect(function () {
        if (recommends.length) {
            var value_1 = recommends.find(function (line) { return line.id === selectedId; });
            setSelectValue(value_1);
        }
    }, [selectedId]);
    var handlePanelClick = function (e) {
        if (!CLICK_RECOMEND) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (CLICK_RECOMEND) {
            CLICK_RECOMEND = false;
        }
    };
    var handlePanelItemClick = function (value) {
        handleOnChange(value);
        setSelectValue(value);
        if (useTreeSelectRC) {
            var treeSelectRef_1 = document.getElementById('TreeSelectRC_Ref');
            setTimeout(function () { return treeSelectRef_1 === null || treeSelectRef_1 === void 0 ? void 0 : treeSelectRef_1.blur(); });
        }
        else {
            CLICK_RECOMEND = true;
        }
    };
    var handleOnChange = function (value) {
        var onChanged = props.onChanged;
        onChanged && onChanged(value);
    };
    return (React.createElement("div", { className: "feeType_recommend_panel", onClick: handlePanelClick },
        React.createElement("div", { className: "title" },
            React.createElement(T, { name: "\u63A8\u8350" })),
        React.createElement("div", { className: "panel_wrapper" }, recommends.map(function (line, index) {
            var _a;
            return (React.createElement(Tag, { onClick: function () { return handlePanelItemClick(line); }, className: classNames('recommend-fee-type-item', (_a = {},
                    _a['recommend-fee-type-item--selected'] = value ? value.id === line.id : false,
                    _a)), icon: React.createElement(FeeTypeIcon, { className: "recommend-fee-type-icon", feetype: line }) }, getSpecificationName(line)));
        }))));
}
function getFullPath(feeType, feeTypeMap) {
    var paths = [feeType.name];
    var item = __assign({}, feeType);
    while (item.parentId) {
        var pFeetype = feeTypeMap[item.parentId];
        if (pFeetype) {
            paths.push(pFeetype.name);
            item = pFeetype;
        }
        else {
            item = {};
        }
    }
    return paths.reverse().join('/');
}
